import { LOCALE } from './locales';

export enum LANGUAGE_REGION {
    EMEA = 'EMEA',
    NCSA = 'NCSA'
}

export const REGION_TO_DEFAULT_LANGUAGE = {
    [LANGUAGE_REGION.EMEA]: LOCALE.EN_GB,
    [LANGUAGE_REGION.NCSA]: LOCALE.EN_US
};

export type IAvailableLanguages = { [key in LANGUAGE_REGION]: string[] };
